<div class="vh-100 m-3 d-flex flex-grow-1">
    <div class="d-flex flex-column flex-grow-1">
        @if (loading) {
            <div class="d-flex justify-content-center align-items-center flex-grow-1">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        } @else {
            <div>
                <span class="fs-4"> {{ "statistics" | translate}}</span>  
                <hr>
            </div>
            <div class="card"> 
                <div class="card-header bg-secondary-subtle">
                    <div class="d-flex">
                        <div class=" col-6">
                            <span class="fs-5"> Uitgevoerde opdrachten  </span>
                        </div>
                        <div class="col-6 d-inline-flex flex-row">
                            <select class="form-control" [(ngModel)]="selectedYear" (change)="onDateChange()">
                                @for (year of years; track $index) {
                                    <option [value]="year">{{ year }}</option>
                                }
                            </select>
                            <select class="form-control" [(ngModel)]="selectedMonth" (change)="onDateChange()">
                                @for (month of months; track $index) {
                                    <option [value]="$index">{{ month }}</option>
                                }
                            </select>  

                            <input
                                type="text"
                                class="form-control"
                                [ngbTypeahead]="search"
                                [inputFormatter]="formatter"
                                [resultFormatter]="formatter"
                                (focus)="onContactFocus($event)"
                                (click)="onContactClick($event)"
                                (selectItem)="onContactChange($event)"
                                #contactInstance="ngbTypeahead"
                                [(ngModel)]="selectedContact"
                            />
                        </div>
                    </div>
                </div>      
                <div class="card-body">
                    <div class="row">
                        @if (yearStatistics.length == 0 ){
                            {{"no_statistics_found" | translate}}
                        } @else {
                            <div class="col-md-4">
                                <div class="fs-5 mb-2">
                                    Aantal opdrachten per maand van jaar {{selectedYear}}
                                </div>
                                <div class="table-md-responsive">
                                    <table class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="text-center col-md-4">
                                                    Maand
                                                </th>
                                                
                                                <th class="text-center">
                                                    Totaal
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (month of months; track $index) {
                                                <tr>
                                                    <td class="text-center col-4">
                                                        {{month}}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ yearStatistics[$index].count }}
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <th class="text-center">
                                                    Totaal
                                                </th>
                                                <th class="text-center">
                                                    {{ yearTotal}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-8">

                                <div class="fs-5 mb-2">
                                    Overzicht maand {{months[selectedMonth]}}
                                </div>
                                <div>
                                    <table class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    Klant
                                                </th>
                                                <th class="text-center">
                                                    Aantal ritten
                                                </th>     
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (stat of contactStatistics; track $index) {
                                                <tr>
                                                    <td class="text-center">
                                                        {{ stat.contact.name }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ stat.jobNames.length }}
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                    
                                </div>
                            </div>
                            <div class="row">
                                <div class="fs-5 mb-2">
                                    Overzicht opdrachten per klant
                                </div>
                                @for (item of contactStatistics; track $index) {
                                    <app-statistics-job-list [opened]="false" [contact]="item.contact" [nameList]="item.jobNames"></app-statistics-job-list>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
</div>
